import { render, staticRenderFns } from "./EssayQuestionsLanding.vue?vue&type=template&id=52742072"
import script from "./EssayQuestionsLanding.vue?vue&type=script&lang=js"
export * from "./EssayQuestionsLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports